"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _SttButton = _interopRequireDefault(require("./../SttButton/SttButton"));
var _excluded = ["onFileChange", "arquivo"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    divExterna: {
      display: 'flex',
      alignItems: 'center'
    }
  };
});
function SttBasicFileSelect(_ref) {
  var onFileChange = _ref.onFileChange,
    _ref$arquivo = _ref.arquivo,
    arquivo = _ref$arquivo === void 0 ? null : _ref$arquivo,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var fileInput = _react["default"].useRef();
  var _React$useState = _react["default"].useState('Selecione um anexo'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    fileName = _React$useState2[0],
    setFileName = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isFileSelected = _React$useState4[0],
    setIsFileSelected = _React$useState4[1];
  var reset = function reset() {
    setFileName('Selecione um anexo');
    setIsFileSelected(false);
    onFileChange(false);
  };
  (0, _react.useEffect)(function () {
    if (arquivo) {
      setFileName(arquivo.name);
      setIsFileSelected(true);
    }
  }, [arquivo]);
  var onChange = function onChange(event) {
    if (event.target.files && event.target.files[0].name) {
      setFileName(event.target.files[0].name);
      setIsFileSelected(true);
      onFileChange(event);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.divExterna
  }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({
    className: classes.textFieldNome,
    variant: "outlined",
    margin: "dense",
    onFocus: function onFocus() {
      return fileInput.current.click();
    },
    fullWidth: true,
    value: fileName,
    disabled: true
  }, props)), !isFileSelected && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    variant: "contained",
    color: "primary",
    className: classes.botaoSelecaoAnexo,
    onClick: function onClick() {
      return fileInput.current.click();
    }
  }, "Selecionar"), /*#__PURE__*/_react["default"].createElement("input", {
    ref: fileInput,
    type: "file",
    onChange: onChange,
    onClick: function onClick(event) {
      return event.target.value = '';
    },
    style: {
      display: 'none'
    }
  })), isFileSelected && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    variant: "contained",
    color: "secondary",
    className: classes.botaoSelecaoAnexo,
    onClick: reset
  }, "Excluir")));
}
var _default = SttBasicFileSelect;
exports["default"] = _default;